import { Workbox } from 'workbox-window';
import { showConfirmAlert } from '@/helpers/alertHelper';

// Páginas públicas (cliente vindo do QR, vitrine de benefícios): sem service worker e
// sem o prompt "Nova versão disponível" — um cliente não instala o app, e o SweetAlert
// em cima do formulário de pesquisa travou a tela de quem estava respondendo.
const PUBLIC_PATH = /^\/(p|beneficio|beneficios)(\/|$)/;

export function setupPWA() {
    if (import.meta.env.DEV) return;
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    if (PUBLIC_PATH.test(window.location.pathname)) return;

    const wb = new Workbox('/sw.js', { scope: '/' });

    wb.addEventListener('waiting', () => {
        showConfirmAlert('Nova versão disponível', { text: 'Recarregar para atualizar?', icon: 'info', confirmText: 'Atualizar', cancelText: 'Depois' }).then((atualizar) => {
            if (atualizar) {
                wb.addEventListener('controlling', () => window.location.reload());
                wb.messageSkipWaiting();
            }
        });
    });

    wb.register().catch((err) => {
        console.error('SW register error', err);
    });
}
